import { Navigate, useLocation } from "react-router-dom"
import { knowledgeTabPath, type KnowledgeTab } from "@/components/knowledge/knowledge-tabs"

/**
 * Library, Templates and Prompts used to be top-level pages
 * (`/app/library`, `/app/templates`, `/app/prompts`). They now live in
 * Knowledge, so old links (bookmarks, onboarding steps, the SharePoint OAuth
 * return) land on the matching tab. The query string and hash carry over:
 * `?sharepoint=connected` must still reach AppLayout's toast handler.
 */
export function LegacyKnowledgeRedirect({ tab }: { tab: KnowledgeTab }) {
  const location = useLocation()
  return (
    <Navigate
      replace
      to={{ pathname: knowledgeTabPath(tab), search: location.search, hash: location.hash }}
    />
  )
}
